import React from 'react';
import { UserData } from '@src/user-data';
import { UserDataConfig } from '@src/config';

export const wrapRootElement = ({ element }) => <UserData options={UserDataConfig}>{element}</UserData>;
